import '@formkit/themes/genesis';

export default {};
